import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header pb-0" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_18 = {
  key: 1,
  class: "table-responsive table_style"
}
const _hoisted_19 = { class: "table table-striped table-hover align-middle" }
const _hoisted_20 = { class: "table-group-divider" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "badge bg-secondary" }
const _hoisted_23 = { class: "feature-key" }
const _hoisted_24 = { class: "description-cell" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "badge bg-info" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "form-check form-switch" }
const _hoisted_34 = ["checked", "onChange", "disabled"]
const _hoisted_35 = { class: "form-check-label text-xs" }
const _hoisted_36 = {
  class: "d-flex gap-2",
  role: "group"
}
const _hoisted_37 = ["onClick", "disabled"]
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center mt-4 pt-3 border-top"
}
const _hoisted_43 = { class: "text-muted" }
const _hoisted_44 = {
  key: 0,
  "aria-label": "Features pagination"
}
const _hoisted_45 = { class: "pagination pagination-sm mb-0" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["onClick", "aria-label", "aria-current"]
const _hoisted_48 = {
  key: 1,
  class: "page-link"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 2,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_51 = { class: "modal-dialog modal-md" }
const _hoisted_52 = { class: "modal-content" }
const _hoisted_53 = { class: "modal-body" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "text-muted" }
const _hoisted_56 = { class: "ms-2" }

import { ref, computed, onMounted, defineAsyncComponent } from "vue";
import { toast } from "vue3-toastify";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeaturesList',
  setup(__props) {

const { canView, canCreate, canUpdate, canDelete } = usePermissions();

const FeatureModal = defineAsyncComponent(
  () => import("@/components/theme/admin/packages/FeatureModal.vue")
);

const FeatureViewModal = defineAsyncComponent(
  () => import("@/components/theme/admin/packages/FeatureViewModal.vue")
);

// State
const features = ref<any[]>([]);
const categories = ref<any[]>([]);
const loading = ref(false);
const searchQuery = ref("");
const filterCategory = ref("");
const filterStatus = ref("");
const sortBy = ref("name");
const currentPage = ref(1);
const itemsPerPage = ref(10);
const totalItems = ref(0);

// Modal state
const showModal = ref(false);
const showViewModal = ref(false);
const showLimitsModal = ref(false);
const selectedFeature = ref<any>(null);
const selectedLimits = ref<any>(null);
const isEditMode = ref(false);

// Computed
const totalPages = computed(() =>
  Math.ceil(totalItems.value / itemsPerPage.value)
);

const startItem = computed(
  () => (currentPage.value - 1) * itemsPerPage.value + 1
);

const endItem = computed(() =>
  Math.min(currentPage.value * itemsPerPage.value, totalItems.value)
);

const visiblePages = computed(() => {
  const delta = 2;
  const range = [];
  const rangeWithDots = [];

  if (totalPages.value <= 1) {
    return [1];
  }

  if (totalPages.value <= 7) {
    for (let i = 1; i <= totalPages.value; i++) {
      range.push(i);
    }
    return range;
  }

  for (
    let i = Math.max(2, currentPage.value - delta);
    i <= Math.min(totalPages.value - 1, currentPage.value + delta);
    i++
  ) {
    range.push(i);
  }

  if (currentPage.value - delta > 2) {
    rangeWithDots.push(1, "...");
  } else {
    rangeWithDots.push(1);
  }

  rangeWithDots.push(...range);

  if (currentPage.value + delta < totalPages.value - 1) {
    rangeWithDots.push("...", totalPages.value);
  } else if (totalPages.value > 1) {
    rangeWithDots.push(totalPages.value);
  }

  return rangeWithDots.filter(
    (page, index, array) => array.indexOf(page) === index
  );
});

// Methods
const fetchFeatures = async () => {
  console.log("🚀 fetchFeatures called");
  try {
    loading.value = true;
    const params: any = {
      page: currentPage.value,
      limit: itemsPerPage.value,
    };

    if (searchQuery.value) {
      params.search = searchQuery.value;
    }

    if (filterCategory.value) {
      params.category = filterCategory.value;
    }

    if (filterStatus.value !== "") {
      params.isActive = filterStatus.value;
    }

    if (sortBy.value) {
      params.sortBy = sortBy.value;
    }

    const response = await apiService.getFeatures(params);

    console.log("🔍 Features API Response:", response);
    console.log("🔍 Response structure:", {
      hasData: !!response.data,
      hasFeatures: !!(response.data && response.data.features),
      directFeatures: !!response.features,
      responseKeys: Object.keys(response || {}),
      dataKeys: response.data ? Object.keys(response.data) : null,
    });

    // Handle the nested response structure
    if (response.data && response.data.features) {
      console.log("✅ Using response.data.features path");
      features.value = response.data.features;
      totalItems.value =
        response.data.pagination?.totalItems || response.data.features.length;
    } else if (response.features) {
      console.log("✅ Using response.features path");
      features.value = response.features;
      totalItems.value =
        response.pagination?.totalItems || response.features.length;
    } else {
      console.log("✅ Using fallback path");
      features.value = response.data || response || [];
      totalItems.value =
        response.total || response.pagination?.total || features.value.length;
    }

    console.log("🔍 Final features array:", features.value);
    console.log("🔍 Final totalItems:", totalItems.value);
  } catch (error: any) {
    console.error("❌ Error fetching features:", error);
    console.error("❌ Error details:", {
      message: error?.message,
      response: error?.response?.data,
      status: error?.response?.status,
    });
    toast.error("Failed to load features");
  } finally {
    loading.value = false;
  }
};

const fetchCategories = async () => {
  try {
    // Assuming we have a categories endpoint - you might need to adjust this
    const response = await apiService.getPackageCategories({ limit: 100 });
    if (response.data && response.data.categories) {
      categories.value = response.data.categories;
    } else if (response.categories) {
      categories.value = response.categories;
    } else {
      categories.value = response.data || response || [];
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    // Continue without categories if they fail to load
  }
};

const handleSearch = () => {
  currentPage.value = 1;
  fetchFeatures();
};

const handleFilter = () => {
  currentPage.value = 1;
  fetchFeatures();
};

const resetFilters = () => {
  searchQuery.value = "";
  filterCategory.value = "";
  filterStatus.value = "";
  sortBy.value = "name";
  currentPage.value = 1;
  fetchFeatures();
};

const changePage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    fetchFeatures();
  }
};

const openCreateModal = () => {
  selectedFeature.value = null;
  isEditMode.value = false;
  showModal.value = true;
};

const editFeature = (feature: any) => {
  selectedFeature.value = { ...feature };
  isEditMode.value = true;
  showModal.value = true;
};

const viewFeature = (feature: any) => {
  selectedFeature.value = feature;
  showViewModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedFeature.value = null;
  isEditMode.value = false;
};

const closeViewModal = () => {
  showViewModal.value = false;
  selectedFeature.value = null;
};

const handleEditFromView = (feature: any) => {
  closeViewModal();
  editFeature(feature);
};

const handleFeatureSaved = () => {
  fetchFeatures();
  closeModal();
  toast.success(
    isEditMode.value
      ? "Feature updated successfully"
      : "Feature created successfully"
  );
};

const handleToggleStatus = (id: string, event: Event) => {
  const target = event.target as HTMLInputElement;
  toggleStatus(id, target.checked);
};

const toggleStatus = async (id: string, status: boolean) => {
  try {
    // Optimistic update
    const featureIndex = features.value.findIndex((feat) => feat._id === id);
    if (featureIndex !== -1) {
      features.value[featureIndex].isActive = status;
    }

    await apiService.toggleFeatureStatus(id);
    toast.success(
      `Feature ${status ? "activated" : "deactivated"} successfully`
    );

    await fetchFeatures();
  } catch (error) {
    console.error("Error toggling status:", error);
    toast.error("Failed to update feature status");

    // Revert optimistic update
    const featureIndex = features.value.findIndex((feat) => feat._id === id);
    if (featureIndex !== -1) {
      features.value[featureIndex].isActive = !status;
    }
  }
};

const deleteFeature = async (id: string) => {
  if (
    !confirm(
      "Are you sure you want to delete this feature? This action cannot be undone."
    )
  ) {
    return;
  }

  try {
    await apiService.deleteFeature(id);
    await fetchFeatures();
    toast.success("Feature deleted successfully");
  } catch (error) {
    console.error("Error deleting feature:", error);
    toast.error("Failed to delete feature");
  }
};

const showLimits = (limits: any) => {
  selectedLimits.value = limits;
  showLimitsModal.value = true;
};

const closeLimitsModal = () => {
  showLimitsModal.value = false;
  selectedLimits.value = null;
};

// Utility functions
const getCategoryName = (category: any): string => {
  // Handle both populated category object and category ID string
  if (typeof category === "object" && category !== null) {
    return category.name || "Unknown";
  } else if (typeof category === "string") {
    const cat = categories.value.find((cat) => cat._id === category);
    return cat ? cat.name : "Unknown";
  }
  return "Unknown";
};

const truncateText = (text: string, maxLength: number): string => {
  if (!text) return "-";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const formatLimitKey = (key: string): string => {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .replace(/([a-z])([A-Z])/g, "$1 $2");
};

const formatLimitValue = (value: any): string => {
  if (typeof value === "number") {
    return value.toLocaleString();
  }
  return value?.toString() || "-";
};

// Lifecycle
onMounted(() => {
  fetchCategories();
  fetchFeatures();
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Breadcrumbs, { title: "Features" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "mb-0" }, [
                  _createElementVNode("i", { class: "fas fa-puzzle-piece me-2" }),
                  _createTextVNode(" Feature Management ")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: openCreateModal,
                    disabled: !_unref(canCreate)('packages')
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                    _createTextVNode(" Add Feature ", -1)
                  ]))], 8, _hoisted_8)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fas fa-search" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "Search features...",
                      onInput: handleSearch
                    }, null, 544), [
                      [_vModelText, searchQuery.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterCategory).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "All Categories", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: category._id,
                        value: category._id
                      }, _toDisplayString(category.name), 9, _hoisted_14))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, filterCategory.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterStatus).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "true" }, "Active", -1),
                    _createElementVNode("option", { value: "false" }, "Inactive", -1)
                  ]))], 544), [
                    [_vModelSelect, filterStatus.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sortBy).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("option", { value: "name" }, "Name", -1),
                    _createElementVNode("option", { value: "key" }, "Key", -1),
                    _createElementVNode("option", { value: "category" }, "Category", -1),
                    _createElementVNode("option", { value: "createdAt" }, "Created Date", -1)
                  ]))], 544), [
                    [_vModelSelect, sortBy.value]
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-1" }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary w-100",
                    onClick: resetFilters,
                    title: "Reset Filters"
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fas fa-undo" }, null, -1)
                  ]))])
                ])
              ]),
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1)
                  ]))]))
                : (features.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("table", _hoisted_19, [
                        _cache[18] || (_cache[18] = _createElementVNode("thead", { class: "table-dark" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Sr No"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Key"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"200px"}
                            }, "Name"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"200px"}
                            }, "Description"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Category"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Default"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Limits"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Status"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (feature, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: feature._id
                            }, [
                              _createElementVNode("td", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + index + 1), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("code", _hoisted_23, _toDisplayString(feature.key), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("strong", null, _toDisplayString(feature.name), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("span", {
                                    title: feature.description,
                                    class: "text-muted"
                                  }, _toDisplayString(truncateText(feature.description, 50)), 9, _hoisted_25)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(getCategoryName(feature.category)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_27, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(
                            feature.enabledByDefault
                              ? 'badge bg-success'
                              : 'badge bg-light text-dark'
                          )
                                }, _toDisplayString(feature.enabledByDefault ? "Yes" : "No"), 3)
                              ]),
                              _createElementVNode("td", _hoisted_28, [
                                (
                            feature.limits &&
                            Object.keys(feature.limits).length > 0
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-info",
                                        onClick: ($event: any) => (showLimits(feature.limits)),
                                        title: "View Limits"
                                      }, [
                                        _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-list" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(Object.keys(feature.limits).length), 1)
                                      ], 8, _hoisted_30)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_31, "-"))
                              ]),
                              _createElementVNode("td", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    checked: feature.isActive,
                                    onChange: ($event: any) => (handleToggleStatus(feature._id, $event)),
                                    disabled: loading.value || !_unref(canUpdate)('packages')
                                  }, null, 40, _hoisted_34),
                                  _createElementVNode("label", _hoisted_35, _toDisplayString(feature.isActive ? "Active" : "Inactive"), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: ($event: any) => (viewFeature(feature)),
                                    title: "View",
                                    disabled: !_unref(canView)('packages')
                                  }, [...(_cache[15] || (_cache[15] = [
                                    _createElementVNode("i", { class: "fas fa-eye" }, null, -1)
                                  ]))], 8, _hoisted_37),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-success",
                                    onClick: ($event: any) => (editFeature(feature)),
                                    title: "Edit",
                                    disabled: !_unref(canUpdate)('packages')
                                  }, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                  ]))], 8, _hoisted_38),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: ($event: any) => (deleteFeature(feature._id)),
                                    title: "Delete",
                                    disabled: !_unref(canDelete)('packages')
                                  }, [...(_cache[17] || (_cache[17] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                  ]))], 8, _hoisted_39)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-puzzle-piece fa-3x text-muted mb-3" }, null, -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "text-muted" }, "No features found", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-muted" }, "Add your first feature to get started.", -1)),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: openCreateModal,
                        disabled: !_unref(canCreate)('packages')
                      }, [...(_cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                        _createTextVNode(" Add Feature ", -1)
                      ]))], 8, _hoisted_41)
                    ])),
              (totalItems.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("small", null, " Showing " + _toDisplayString(startItem.value) + " to " + _toDisplayString(endItem.value) + " of " + _toDisplayString(totalItems.value) + " features ", 1)
                    ]),
                    (totalPages.value > 1)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_44, [
                          _createElementVNode("ul", _hoisted_45, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: currentPage.value <= 1 }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (changePage(currentPage.value - 1))),
                                disabled: currentPage.value <= 1,
                                "aria-label": "Previous page"
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
                                _createElementVNode("span", { class: "ms-1 d-none d-sm-inline" }, "Previous", -1)
                              ]))], 8, _hoisted_46)
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                class: _normalizeClass(["page-item", { active: page === currentPage.value }])
                              }, [
                                (typeof page === 'number')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "page-link",
                                      onClick: ($event: any) => (changePage(page)),
                                      "aria-label": `Go to page ${page}`,
                                      "aria-current": 
                          page === currentPage.value ? 'page' : undefined
                        
                                    }, _toDisplayString(page), 9, _hoisted_47))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(page), 1))
                              ], 2))
                            }), 128)),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: currentPage.value >= totalPages.value }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (changePage(currentPage.value + 1))),
                                disabled: currentPage.value >= totalPages.value,
                                "aria-label": "Next page"
                              }, [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("span", { class: "me-1 d-none d-sm-inline" }, "Next", -1),
                                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                              ]))], 8, _hoisted_49)
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(FeatureModal), {
          key: 0,
          show: showModal.value,
          feature: selectedFeature.value,
          "is-edit": isEditMode.value,
          categories: categories.value,
          onClose: closeModal,
          onSaved: handleFeatureSaved
        }, null, 8, ["show", "feature", "is-edit", "categories"]))
      : _createCommentVNode("", true),
    (showViewModal.value)
      ? (_openBlock(), _createBlock(_unref(FeatureViewModal), {
          key: 1,
          show: showViewModal.value,
          feature: selectedFeature.value,
          categories: categories.value,
          onClose: closeViewModal,
          onEdit: handleEditFromView
        }, null, 8, ["show", "feature", "categories"]))
      : _createCommentVNode("", true),
    (showLimitsModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[25] || (_cache[25] = _createElementVNode("h5", { class: "modal-title" }, [
                  _createElementVNode("i", { class: "fas fa-list me-2" }),
                  _createTextVNode(" Feature Limits ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeLimitsModal
                })
              ]),
              _createElementVNode("div", _hoisted_53, [
                (selectedLimits.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLimits.value, (value, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "mb-2"
                        }, [
                          _createElementVNode("strong", _hoisted_55, _toDisplayString(formatLimitKey(String(key))) + ":", 1),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(formatLimitValue(value)), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeLimitsModal
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})